export default __webpack_public_path__ + "static/media/great-support.13341f4e.jpg";